module.exports = __webpack_public_path__ + "assets/img/3992-et.svg";